module.exports = __webpack_public_path__ + "img/questionnaire.83a58f2f.svg";